// Invoice numbers are saved in full ("PL-2026-0018") but lists show the
// short form ("PL-0018"). Search must find either, so a user can type
// exactly what they see.

/** "PL-2026-0018" → "PL-0018" (same rule as the lists' lotNoDisplay). */
export function shortInvoiceNo(invoiceNo: string): string {
  const m = (invoiceNo ?? '').match(/^([A-Za-z]+)-\d+-(\d+)$/);
  return m ? `${m[1]}-${m[2].slice(-4)}` : (invoiceNo ?? '');
}

/** True when a lower-cased search matches the full or the short invoice number. */
export function invoiceNoMatches(invoiceNo: string | undefined, q: string): boolean {
  const full = (invoiceNo ?? '').toLowerCase();
  return full.includes(q) || shortInvoiceNo(invoiceNo ?? '').toLowerCase().includes(q);
}
